
import React, { useState, useEffect } from "react";
import "./createTeam.scss";
import Button from "components/Button/index";

const CreateTeam = ({ handleNextStep, updateRoleName, initialRoleName }) => {
  const [teamName, setTeamName] = useState(initialRoleName || "");
  const [error, setError] = useState("");

  useEffect(() => {
    setTeamName(initialRoleName || "");
  }, [initialRoleName]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setError(value.length < 3 ? "Team name must be at least 3 characters long" : "");
    setTeamName(value);
    updateRoleName(value);
  };

  const handleKeyDown=(e)=>{
    if(e.key==="Enter"){
      e.preventDefault();
      if (teamName.trim()) {
        handleNextStep();
      } else {
        setError("Team name cannot be empty");
      }
    }
  };

  return (
    <div className="createTeamWrapper">
      <div className="createTeamWrapperContent">
        <p>Team Name</p>
        <input
          type="text"
          placeholder="Enter team name"
          value={teamName}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
         {error && <p style={{ color: "red" }}>{error}</p>}
      </div>
      <Button
        type="violet"
        title="Assign Access"
        onClick={handleNextStep}
        disabled={!teamName.trim()}
      />
    </div>
  );
};

export default CreateTeam;